import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import scrollToTop from '../components/hooks/ScrollToTop';
import { Box } from '@mui/material';

// Privacy Policy component

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  useEffect(() => {
    scrollToTop();
  }, []);

  useEffect(() => {
    const html = document.getElementsByTagName('html')[0];
    html.setAttribute('data-wf-page', '68603f7a056ff6f78f58cb16');
    html.setAttribute('data-wf-site', '68603f7a056ff6f78f58cab1');
    window.Webflow && window.Webflow.destroy();
    window.Webflow && window.Webflow.ready();
    window.Webflow && window.Webflow.require('ix2').init();
    document.dispatchEvent(new Event('readystatechange'));
  }, []);
  const html = t('privacyPolicyFullNOA');

  if (html !== 'privacyPolicyFullNOA') {
    return (
      <Box>
        <Box className='page-wrapper'>
          <Navbar />
          <section className='blog-area'>
            <Box className='hero-wrapper hero-7 space' id='hero'>
              <Box className='container-space'>
                <Box className='row gx-4 align-items-center justify-content-between flex-row-reverse max-content-wraper'>
                  <Box className='col-lg-12 col-md-6'>
                    <Box
                      dangerouslySetInnerHTML={{ __html: t('privacyPolicyFullNOA') }}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          </section>
          <Footer />
        </Box>
      </Box>
    );
  }
  return (
    <div>
      <div className='page-wrapper'>
        <Navbar />
        <section className='blog-area'>
          <div className='hero-wrapper hero-7 space' id='hero'>
            <div className='container-space'>
              <div className='row gx-4 align-items-center justify-content-between flex-row-reverse max-content-wraper'>
                <div className='col-lg-12 col-md-6'>
                  <h3
                    className='text-center links-heading item-heading-font'
                    style={{ fontSize: '26px', color: '#ee7c2c' }}
                  >
                    {t('PrivacyPolicy')}
                  </h3>
                  <div className='card-text item-content-font'>
                    <div className=''>
                      <div className='mt-4'>
                        <p
                          style={{ fontSize: '15px' }}
                          className='sl_whiteout notranslate mb-0-5'
                        >
                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('thankYouForUsingEaconomy')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('eaconomyUsWeOurOperates')}{' '}
                              <Link to='/' className='orange-noa'>
                                https://noaitaly.io
                              </Link>{' '}
                              {t('theSiteAndTheServices')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('thisPrivacyStatementHasCreated')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('pleaseReadThisPolicyTo')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <strong>
                              <u>
                                <span style={{ fontSize: '16px' }}>
                                  {t('soleDataController')}
                                </span>
                              </u>
                            </strong>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('eaconomyIsTheSoleData')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('weWillNotSellRentLend')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('weWillUseYourInformation')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('unlessYouAskUsNotToWe')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <strong>
                              <u>
                                <span style={{ fontSize: '16px' }}>
                                  {t('informationWeCollect')}
                                </span>
                              </u>
                            </strong>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('personalInformationThis')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('deviceInformationThisIs')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('weCollectDeviceInformation')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('logFilesTrackActions')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('likeManySitesWeUse')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('thisHelpsUsGatherFeedback')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('youCanInstructYourBrowser')}
                            </span>
                          </p>

                          <ul className='mb-0-5'>
                            <li>
                              <Link
                                to='https://support.microsoft.com/en-us/products/windows'
                                target='_blank'
                                className='orange-noa'
                              >
                                <span style={{ fontSize: '16px' }}>
                                  {t('cookieSettingsInInternet')}
                                </span>
                              </Link>
                            </li>
                            <li>
                              <Link
                                to='https://support.mozilla.org/en-US/kb/cookies'
                                target='_blank'
                                className='orange-noa'
                              >
                                <span style={{ fontSize: '16px' }}>
                                  {t('cookieSettingsInFirefox')}
                                </span>
                              </Link>
                            </li>
                            <li>
                              <Link
                                to='https://support.google.com/chrome/answer/95647?hl=en'
                                target='_blank'
                                className='orange-noa'
                              >
                                <span style={{ fontSize: '16px' }}>
                                  {t('cookieSettingsInChrome')}
                                </span>
                              </Link>
                            </li>
                            <li>
                              <span style={{ fontSize: '16px' }}>
                                <Link
                                  to='https://support.apple.com/kb/PH5042?locale=en_GB'
                                  target='_blank'
                                  className='orange-noa'
                                >
                                  {t('cookieSettingsInSafariWeb')}
                                </Link>{' '}
                                {t('and')}
                                <Link
                                  to='https://support.apple.com/en-gb/HT201265'
                                  target='_blank'
                                  className='orange-noa'
                                >
                                  {t('iOS')}
                                </Link>
                              </span>
                            </li>
                          </ul>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('forMoreInformationAbout')}{' '}
                              <Link
                                to='http://www.allaboutcookies.org/'
                                target='_blank'
                                className='orange-noa'
                              >
                                http://www.allaboutcookies.org
                              </Link>
                              .
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('cookiesAreDataFilesThat')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('webBeaconsTagsAnd')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('iPAddressesAreUsed')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('weMayCollectAnalytics')}
                              <Link
                                to='https://policies.google.com/privacy/partners'
                                target='_blank'
                                className='orange-noa'
                              >
                                https://policies.google.com/privacy/partners
                              </Link>
                              ,{t('andViewItsCurrently')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <strong>
                              <u>
                                <span style={{ fontSize: '16px' }}>
                                  {t('doNotTrack')}
                                </span>
                              </u>
                            </strong>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('pleaseNoteThatWeDo')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <strong>
                              <u>
                                <span style={{ fontSize: '16px' }}>
                                  {t('howDoWeUseYourPersonal')}
                                </span>
                              </u>
                            </strong>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('weUseTheRegistration')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('additionallyWeMayUse')}
                            </span>
                          </p>

                          <ul className='mb-0-5'>
                            <li>
                              <span style={{ fontSize: '16px' }}>
                                {t('communicateWithYou')}
                              </span>
                            </li>
                            <li>
                              <span style={{ fontSize: '16px' }}>
                                {t('screenOurOrdersFor')}
                              </span>
                            </li>
                            <li>
                              <span style={{ fontSize: '16px' }}>
                                {t('whenInLineWithThe')}
                              </span>
                            </li>
                          </ul>

                          <p className='mb-0-5'>
                            <strong>
                              <u>
                                <span style={{ fontSize: '16px' }}>
                                  {t('accountInformation')}
                                </span>
                              </u>
                            </strong>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('asAMemberYouAre')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <strong>
                              <u>
                                <span style={{ fontSize: '16px' }}>
                                  {t('yourAccessToControl')}
                                </span>
                              </u>
                            </strong>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('thePersonalInformation')}{' '}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('weWillTryAndRespond')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <strong>
                              <u>
                                <span style={{ fontSize: '16px' }}>
                                  {t('eUCitizensYourRights')}
                                </span>
                              </u>
                            </strong>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('ifYouAreAEuropean')}{' '}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('additionallyIfYouEuropean')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <strong>
                              <u>
                                <span style={{ fontSize: '16px' }}>
                                  {t('dataRetention')}
                                </span>
                              </u>
                            </strong>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('whenYouPlaceAnOrder')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <strong>
                              <u>
                                <span style={{ fontSize: '16px' }}>
                                  {t('surveysAndContests')}
                                </span>
                              </u>
                            </strong>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('fromTimeToTimeOur')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <strong>
                              <u>
                                <span style={{ fontSize: '16px' }}>{t('children')}</span>
                              </u>
                            </strong>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('childrenAreNotEligible')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <strong>
                              <u>
                                <span style={{ fontSize: '16px' }}>
                                  {t('useOfTestimoniesAndReviews')}
                                </span>
                              </u>
                            </strong>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('weMaySelectAndPost')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <strong>
                              <u>
                                <span style={{ fontSize: '16px' }}>{t('links')}</span>
                              </u>
                            </strong>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('thisWebsiteContainsLinks')}{' '}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('itIsPossibleThatSome')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <strong>
                              <u>
                                <span style={{ fontSize: '16px' }}>{t('security')}</span>
                              </u>
                            </strong>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('weUseReasonableAnd')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('whereverWeCollectSensitive')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('whileWeUseEncryptionTo')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <strong>
                              <u>
                                <span style={{ fontSize: '16px' }}>
                                  {t('referringPeople')}
                                </span>
                              </u>
                            </strong>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('ifYouChooseToUse')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <strong>
                              <u>
                                <span style={{ fontSize: '16px' }}>
                                  {t('enUsAndSwissUsPrivacy')}
                                </span>
                              </u>
                            </strong>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('weComplyWithTheEuUs')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('toLearnMoreAboutThe')}
                              <Link
                                to='http://www.privacyshield.gov/'
                                target='_blank'
                                className='orange-noa'
                              >
                                www.privacyshield.gov
                              </Link>
                              .{t('forFullDefinitionsOf')}
                              <Link
                                to='http://www.privacyshield.gov/EU-US-Framework.'
                                target='_blank'
                                className='orange-noa'
                              >
                                www.privacyshield.gov/EU-US-Framework
                              </Link>
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('underThePrivacyShield')}
                              <Link
                                to='mailto:support@noaitaly.io'
                                target='_blank'
                                className='orange-noa'
                              >
                                &nbsp;support@noaitaly.io
                              </Link>
                              .
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <strong>
                              <u>
                                <span style={{ fontSize: '16px' }}>
                                  {t('disclosure')}
                                </span>
                              </u>
                            </strong>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('weMayDisclosePersonal')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <strong>
                              <u>
                                <span style={{ fontSize: '16px' }}>
                                  {t('acquisitionsOrChangesIn')}
                                </span>
                              </u>
                            </strong>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('inTheEventThatTheCompany')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <strong>
                              <u>
                                <span style={{ fontSize: '16px' }}>
                                  {t('Revisions and Changes')}
                                </span>
                              </u>
                            </strong>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('thisPrivacyPolicyIs')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('weReserveTheRightTo')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('ifWeMakeAnyMaterialChanges')}
                            </span>
                          </p>

                          <p className='mb-0-5'>
                            <strong>
                              <u>
                                <span style={{ fontSize: '16px' }}>{t('contactUs')}</span>
                              </u>
                            </strong>
                          </p>

                          <p className='mb-0-5'>
                            <span style={{ fontSize: '16px' }}>
                              {t('forMoreInformationOur')}{' '}
                            </span>
                            <span style={{ fontSize: '16px' }}>
                              <Link
                                to='mailto:support@noaitaly.io'
                                className='orange-noa'
                              >
                                support@noaitaly.io
                              </Link>{' '}
                              {t('orByMailUsing')}
                            </span>
                          </p>

                          {/* <p className="mb-0-5">
                          <span style={{ fontSize: "16px" }}>
                            {t("festivalPlazaDrive1980")}
                          </span>
                        </p>

                        <p className="mb-0-5">
                          <span style={{ fontSize: "16px" }}>
                            {t("lasVegasNV89135")}
                          </span>
                        </p>

                        <p className="mb-0-5">
                          <span style={{ fontSize: "16px" }}>
                            {t("unitedStatesOfAmerica")}
                          </span>
                        </p>
                         */}
                          <p className="mb-0-5">
                            <span style={{ fontSize: "16px" }}>
                              Milano (MI) Corso Italia 3 (20122)
                            </span>
                          </p>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </div>
  );
};

export default PrivacyPolicy;
